import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgParamLocalSiderealTime = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Frame",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M12.0007 6.22287V12.0007H16.334M20.6673 12.0007C20.6673 13.1388 20.4431 14.2658 20.0076 15.3172C19.5721 16.3687 18.9337 17.3241 18.1289 18.1289C17.3241 18.9337 16.3687 19.5721 15.3172 20.0076C14.2658 20.4431 13.1388 20.6673 12.0007 20.6673C10.8625 20.6673 9.73555 20.4431 8.68406 20.0076C7.63257 19.5721 6.67717 18.9337 5.87239 18.1289C5.06762 17.3241 4.42924 16.3687 3.9937 15.3172C3.55815 14.2658 3.33398 13.1388 3.33398 12.0007C3.33398 9.70211 4.24708 7.49771 5.87239 5.87239C7.49771 4.24708 9.70211 3.33398 12.0007 3.33398C14.2992 3.33398 16.5036 4.24708 18.1289 5.87239C19.7542 7.49771 20.6673 9.70211 20.6673 12.0007Z",
			stroke: "var(--stroke-0, #DFCBF5)",
			strokeOpacity: .7,
			strokeWidth: .962963,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})
});
export default SvgParamLocalSiderealTime;
